/* Theme-owned cart transactions. No fetch interception, polling or MutationObserver. */
(() => {
  'use strict';
  if (window.Gift0422) return;
  const core=window.Gift0422Core;
  const root=window.Shopify?.routes?.root || '/';
  const nativeFetch=window.fetch.bind(window);
  let tail=Promise.resolve(), pending=0, last=null, warning='', checkoutRunning=false, verified=false;
  // Respuesta mas reciente del servidor (estado del regalo + carrito ya dibujado). Evita volver a pedirlos.
  let cache=null, optimisticColor=null, primed=null;
  const blocked=new Set();
  try { JSON.parse(sessionStorage.getItem('0422-gift-blocks') || '[]').forEach(k=>blocked.add(k)); } catch (_) {}
  function message(text) {
    warning=String(text);
    document.querySelectorAll('[data-gift-message]').forEach(el=>{el.textContent=warning;el.closest('[data-gift-panel]').hidden=false;});
  }
  async function fetchTimed(url,options={}) {
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),15000);
    try { return await nativeFetch(url,{...options,signal:controller.signal,credentials:'same-origin',cache:'no-store'}); }
    finally {clearTimeout(timer);}
  }
  async function json(url,options={}) {
    const response=await fetchTimed(url,options);
    const data=await response.json();
    if (!response.ok || data.errors || data.status >= 400) {
      const error=new Error(data.description || data.message || 'No se pudo actualizar el carrito.');
      error.status=response.status;
      throw error;
    }
    return data;
  }
  const post=(endpoint,body)=>json(root+'cart/'+endpoint+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
  // Secciones que se piden junto con el estado: asi el carrito se redibuja sin una peticion extra.
  function cartEntries() {
    const main=document.querySelector('main cart-items');
    const entries=[];
    if (document.querySelector('#CartDrawer-Body')) entries.push({section:'cart-drawer',selector:'#CartDrawer-Body'});
    if (main?.id) entries.push({section:main.id,selector:'cart-items'});
    return entries;
  }
  const sectionIds=()=>['gift-0422-state',...cartEntries().map(e=>e.section)];
  function parseState(html) {
    if (!html) throw new Error('No se pudo leer la configuración del regalo.');
    const node=new DOMParser().parseFromString(html,'text/html').querySelector('[data-gift-state]');
    if (!node) throw new Error('Falta la sección gift-0422-state.');
    const state=JSON.parse(node.textContent);
    if (!Array.isArray(state.cart?.items) || !Array.isArray(state.candidates) || !Number.isFinite(state.eligible_total)) throw new Error('Estado del carrito inválido.');
    return state;
  }
  function remember(sections) {
    cache=null;
    try { cache={state:parseState(sections?.['gift-0422-state']),sections,fresh:true}; } catch (_) { cache=null; }
  }
  async function read() {
    // Justo despues de quitar/agregar, el servidor ya devolvio el estado actualizado: se reutiliza una vez.
    if (cache?.fresh) { cache.fresh=false; return cache.state; }
    // Cambio de color sobre un carrito recien verificado: se parte del ultimo estado conocido.
    // Si estuviera desactualizado, Shopify rechaza el cambio y el clic se reintenta con datos frescos.
    if (primed) { const s=primed; primed=null; return s; }
    const url=new URL(location.pathname,location.origin);
    url.searchParams.set('sections',sectionIds().join(','));
    const sections=await json(url);
    const state=parseState(sections['gift-0422-state']);
    cache={state,sections,fresh:false};
    return state;
  }
  async function mutate(endpoint,body,withCart) {
    cache=null;
    // Quitar: solo el estado (liviano). Agregar: estado + carrito dibujado, para no pedirlo despues.
    const ids=withCart ? sectionIds() : ['gift-0422-state'];
    const data=await post(endpoint,{...body,sections:ids.join(','),sections_url:location.pathname});
    remember(data.sections);
    return data;
  }
  const io={read,change:(id,quantity)=>mutate('change',{id,quantity},false),add:(id,properties)=>mutate('add',{items:[{id,quantity:1,properties}]},true),
    blocked:key=>blocked.has(key),block:key=>{blocked.add(key);try {sessionStorage.setItem('0422-gift-blocks',JSON.stringify([...blocked].slice(-10)));}catch(_) {}}};
  function paint() {
    if (!last) return;
    const {state:s,notice}=last;
    const gift=s.cart.items.find(core.owned);
    const color=gift && s.candidates.find(c=>c.id===gift.variant_id)?.color;
    const remaining=Math.max(0,core.THRESHOLD-s.eligible_total);
    const money=new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(remaining/100);
    document.querySelectorAll('[data-gift-panel]').forEach(panel=>{
      panel.hidden=s.currency!=='COP';
      panel.querySelector('[data-gift-message]').textContent=warning || notice || (gift?.final_line_price===0 ? '¡Desbloqueaste tu Travel Bag! Tu regalo está en el carrito.' : remaining ? `Te faltan ${money} para desbloquear tu Travel Bag.` : 'Estamos verificando tu regalo.');
      panel.querySelector('progress').value=Math.min(core.THRESHOLD,s.eligible_total);
      panel.querySelector('[data-gift-colors]').hidden=!gift;
      panel.querySelectorAll('[data-gift-color]').forEach(button=>{
        const candidate=s.candidates.find(c=>c.color===button.dataset.giftColor);
        const unavailable=!candidate?.valid || !candidate?.available;
        button.toggleAttribute('data-gift-unavailable',unavailable);
        button.disabled=!!pending || unavailable;
        button.setAttribute('aria-pressed',String((optimisticColor || color)===button.dataset.giftColor));
      });
    });
  }
  function busy() {
    document.documentElement.toggleAttribute('data-gift-busy',pending>0);
    document.querySelectorAll('cart-items, cart-drawer-items').forEach(el=>el.setAttribute('aria-busy',String(pending>0)));
    document.querySelectorAll('.cart__dynamic-checkout').forEach(el=>{
      el.inert=pending>0 || !verified;
      el.setAttribute('aria-busy',String(pending>0 || !verified));
    });
    paint();
  }
  function enqueue(work) {
    pending++;verified=false;busy();
    const execute=()=>navigator.locks ? navigator.locks.request('0422-cart',work) : work();
    const result=tail.then(execute,execute);
    tail=result.catch(()=>{});
    return result.finally(()=>{pending--;busy();});
  }
  async function render(s) {
    const main=document.querySelector('main cart-items');
    const entries=cartEntries();
    if (!entries.length) {paint();return {};}
    let sections=cache && cache.state===s && entries.every(e=>cache.sections?.[e.section]) ? cache.sections : null;
    if (!sections) {
      const url=new URL(location.pathname,location.origin);
      url.searchParams.set('sections',entries.map(e=>e.section).join(','));
      sections=await json(url);
    }
    const replacements=entries.map(e=>{
      if (!sections[e.section]) throw new Error('No se pudo actualizar la vista del carrito.');
      const source=new DOMParser().parseFromString(sections[e.section],'text/html').querySelector(e.selector);
      const target=e.section==='cart-drawer'?document.querySelector(e.selector):main;
      if (!source || !target) throw new Error('La estructura del carrito cambió.');
      return {source,target};
    });
    // The theme reuses the terms ID in both carts. Preserve by form/name,
    // including unsaved notes and cart attributes, rather than by global ID.
    const fields=[...document.querySelectorAll('input[name="terms"], [name="note"], [name^="attributes["]')]
      .filter(el=>el.form?.id)
      .map(el=>({formId:el.form.id,name:el.name,value:el.value,checked:el.checked,type:el.type}));
    const focus=document.activeElement;
    const focusedIdentity=focus?.closest('[data-gift-line]')?.dataset.giftLine;
    const focusedName=focus?.getAttribute('name');
    const focusedColor=focus?.dataset.giftColor;
    const focusWasInCart=replacements.some(({target})=>target.contains(focus));
    replacements.forEach(({source,target})=>{target.innerHTML=source.innerHTML;});
    fields.forEach(field=>{
      const form=document.getElementById(field.formId);
      if(!form) return;
      [...form.elements].filter(el=>el.name===field.name && (field.type!=='radio' || el.value===field.value)).forEach(el=>{
        el.value=field.value;
        if(field.checked!==undefined) el.checked=field.checked;
      });
    });
    document.querySelectorAll('.cart-count-badge,.cart-drawer__title-counter,.cart__title-counter').forEach(el=>{
      el.textContent=s.cart.item_count;
      if(el.classList.contains('cart-count-badge')) el.classList.toggle('hidden',s.cart.item_count===0);
    });
    paint();
    if (focusedIdentity && focusedName) {
      const requested=JSON.parse(focusedIdentity);
      const rows=[...document.querySelectorAll('[data-gift-line]')];
      const row=rows.find(el=>core.identity(JSON.parse(el.dataset.giftLine))===core.identity(requested));
      row?.querySelector('[name="updates[]"]')?.focus({preventScroll:true});
    } else if (focusedColor) {
      document.querySelector('[data-gift-color="'+focusedColor+'"]')?.focus({preventScroll:true});
    } else if (focusWasInCart) {
      document.querySelector('cart-drawer.is-visible [data-drawer-close]')?.focus({preventScroll:true});
    }
    busy();
    if (typeof window.updateFreeShipping==='function') window.updateFreeShipping();
    return sections;
  }
  async function settle(color) {
    warning='';
    cache=null;
    try {
      last=await core.reconcile(io,{color});
    } finally {
      primed=null;
    }
    const sections=await render(last.state);
    verified=true;
    return sections;
  }
  async function request(url,options) {
    // Snapshot the form now; later DOM replacements must not change the queued intent.
    const copy={...options};
    if (options.body instanceof FormData) {
      copy.body=new FormData();
      for (const [key,value] of options.body) copy.body.append(key,value);
      copy.body.delete('sections');copy.body.delete('sections_url');
    }
    return enqueue(async()=>{
      if (typeof copy.body==='string') {
        const body=JSON.parse(copy.body);
        if (body._giftIdentity) {
          const cart=await json(root+'cart.js');
          body.id=core.locate(cart.items,body._giftIdentity).key;
          delete body._giftIdentity;delete body.line;
          if (!Number.isInteger(body.quantity) || body.quantity<0) throw new Error('Cantidad inválida.');
        }
        delete body.sections;delete body.sections_url;
        copy.body=JSON.stringify(body);
      }
      let response, data;
      try {
        response=await fetchTimed(url,copy);
        data=await response.json();
      } catch (error) {
        message('No pudimos confirmar la actualización. Revisa el carrito antes de repetirla.');
        throw error;
      }
      if (!response.ok && !data.status) data.status=response.status;
      try {
        data.sections=await settle();
      } catch (error) {
        // The purchase item may already have been added. Do not report an add failure
        // or automatically resend it just because gift reconciliation/rendering failed.
        message('El carrito cambió, pero falta verificar el regalo. Reintenta antes de pagar.');
        console.error('[0422 gift]',error);
      }
      data.__0422Rendered=true;
      return new Response(JSON.stringify(data),{status:response.status,headers:{'Content-Type':'application/json'}});
    });
  }
  const sync=color=>enqueue(()=>settle(color));
  window.Gift0422={request,sync,message};
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-gift-color]');
    if (!button || button.disabled) return;
    event.preventDefault();
    if (button.getAttribute('aria-pressed')==='true') return;
    const color=button.dataset.giftColor;
    optimisticColor=color;
    paint();
    // Se toma el estado antes de encolar: enqueue() marca el carrito como no verificado.
    const known=!pending && verified && last ? last.state : null;
    const run=state=>enqueue(()=>{ primed=state; return settle(color); });
    run(known)
      .catch(()=>run(null))
      .catch(()=>message('No pudimos confirmar el cambio de color. Reintenta antes de pagar.'))
      .finally(()=>{optimisticColor=null;paint();});
  });
  const permitted=new WeakSet();
  document.addEventListener('submit',async event=>{
    const form=event.target;
    const submitter=event.submitter;
    if (permitted.has(form)) {permitted.delete(form);return;}
    if (submitter?.name!=='checkout') return;
    event.preventDefault();event.stopImmediatePropagation();
    if (checkoutRunning) return;
    checkoutRunning=true;
    const formId=form.id;
    try {
      await sync();
      const current=document.getElementById(formId);
      const button=current?.querySelector('[name="checkout"]');
      if (!current || !button || !current.reportValidity()) return;
      // Quantity edits have already been committed through the queue. Submitting
      // updates[] again can target reordered lines (and this theme duplicates
      // the mobile/desktop controls). Checkout must only submit checkout/terms.
      current.querySelectorAll('[name="updates[]"]').forEach(input=>{input.disabled=true;});
      // The fresh form retains terms and authoritative quantities. Native submission
      // preserves Shopify checkout handling and browser validation.
      permitted.add(current);
      current.requestSubmit(button);
      // Restore if another theme/app handler prevented navigation.
      setTimeout(()=>current.querySelectorAll('[name="updates[]"]').forEach(input=>{input.disabled=false;}),0);
    } catch (_) {message('No pudimos verificar tu carrito. Reintenta el pago en unos segundos.');}
    finally {checkoutRunning=false;}
  },true);
  document.addEventListener('click',async event=>{
    const link=event.target.closest('a[href]');
    if (!link || event.defaultPrevented) return;
    const url=new URL(link.href,location.origin);
    if (url.origin!==location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    if (checkoutRunning) return;
    checkoutRunning=true;
    try {await sync();location.assign(url.href);} catch (_) {message('No pudimos verificar tu carrito. Reintenta antes de pagar.');}
    finally {checkoutRunning=false;}
  },true);
  const initialize=()=>sync().catch(()=>message('No pudimos verificar el regalo. Reintenta antes de pagar.'));
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true}); else initialize();
  window.addEventListener('pageshow',event=>{if(event.persisted) initialize();});
})();
